// extracted by mini-css-extract-plugin
export var cardBody = "singleWebinarItem-module--cardBody--358a5";
export var webinarConnectGradient = "singleWebinarItem-module--webinarConnectGradient--33583";
export var webinarFeaturedCardButton = "singleWebinarItem-module--webinarFeaturedCardButton--e7bdf";
export var webinarItemCard = "singleWebinarItem-module--webinarItemCard--36f65";
export var webinarItemCardButton = "singleWebinarItem-module--webinarItemCardButton--9def5";
export var webinarItemFeaturedCard = "singleWebinarItem-module--webinarItemFeaturedCard--14978";
export var webinarItemFeaturedCardType = "singleWebinarItem-module--webinarItemFeaturedCardType--a3367";